import { LoadingScreen } from './LoadingScreen';

interface Props {
  loading: boolean;
  children: React.ReactElement;
}

const LoadingGate = ({ loading, children }: Props) => {
  if (loading) {
    return <LoadingScreen />;
  }

  return children;
};

export { LoadingGate };
